export const getBaseUrl = (): string => {
  return window.location.origin;
}

export const BaseApiUrl = getBaseUrl() + '/api';
export const BaseOdataUrl = getBaseUrl() + '/odata';